<script>
import { connexionEmits, connexionProps, useConnexion } from "./mixin";

import Popin from "@/components/molecules/popin";
import ConnexionForm from "@/components/organisms/connexion/connexion-form";
import MdpOublieForm from "@/containers/connexion/mdp-oublie-form";
import MdpOublieConfirmation from "@/containers/connexion/mdp-oublie-confirmation";

export default {
  name: "Connexion",
  components: {
    Popin,
    ConnexionForm,
    MdpOublieForm,
    MdpOublieConfirmation
  },
  props: {
    popin: {
      type: Boolean,
      default: true
    },
    popinVisible: {
      type: Boolean,
      default: false
    },
    ...connexionProps()
  },
  emits: ["forgotPassword", "createAccount", ...connexionEmits()],
  methods: {
    forgotPassword() {
      this.$emit("forgotPassword");
      this.$refs.popinMdpOublie.show();
    }
  },
  setup(props, context) {
    const { email, emailSended, resetFormPassword, resetPassword, connexion } =
      useConnexion(context);
    return {
      email,
      emailSended,
      resetFormPassword,
      resetPassword,
      connexion
    };
  }
};
</script>

<template>
  <div>
    <Popin
      v-if="popin"
      :visible="popinVisible"
      size="md"
      aria-label="Connexion"
      v-bind="extractListenersFromAttrs($attrs)"
    >
      <ConnexionForm
        :display-create-account="displayCreateAccount"
        :error="error"
        :state="state"
        :captcha-key="captchaKey"
        @connexion="connexion"
        @createAccount="$emit('createAccount')"
        @forgotPassword="forgotPassword"
        @hidden="$emit('hidden')"
      />
    </Popin>
    <ConnexionForm
      v-else
      :error="error"
      :display-create-account="displayCreateAccount"
      :state="state"
      @connexion="connexion"
      @createAccount="$emit('createAccount')"
      @forgotPassword="forgotPassword"
    />
    <Popin
      ref="popinMdpOublie"
      size="md"
      aria-label="Mot de passe oublié"
      @closed="resetFormPassword()"
    >
      <MdpOublieForm
        v-if="!emailSended"
        @resetPassword="resetPassword"
      />
      <MdpOublieConfirmation
        v-if="email && emailSended"
        :email="email"
      />
    </Popin>
  </div>
</template>
